import { HttpClientModule } from '@angular/common/http';
import { FSUserApi } from './../../sdk/services/custom/FSUser';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from './services/data.service';



@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [],
  providers: [
    FSUserApi
  ]
})
export class DataServiceModule {
  static forRoot(): ModuleWithProviders<DataServiceModule> {
    return {
      ngModule: DataServiceModule,
      providers: [
        DataService,
      ]
    };
  }

}
